<i class="icon guide" (click)="openHelp()" style="cursor: pointer"></i>

<p-drawer
  [(visible)]="drawerVisible"
  appendTo="body"
  position="right"
  styleClass="instructions-drawer"
  [baseZIndex]="10000"
  [style]="drawerStyle"
>
  <ng-template pTemplate="header">
    <div class="instructions-drawer-header">
      <button
        pButton
        pRipple
        type="button"
        [icon]="maximized ? 'pi pi-window-minimize' : 'pi pi-window-maximize'"
        class="p-button-text p-button-sm p-button-secondary"
        [pTooltip]="
          (maximized ? 'common.minimize' : 'common.maximize') | translate
        "
        tooltipPosition="top"
        (click)="toggleMaximize()"
      ></button>
      <span class="p-drawer-title instructions-drawer-title">{{
        'common.instructions-title' | translate
      }}</span>
    </div>
  </ng-template>
  @if (drawerVisible) {
    <app-help-browser [startSlug]="displayedSlug"></app-help-browser>
  }
</p-drawer>
